import React from "react";

function BS4_Scrollspy() {
  return (
    <div>
      <h1>BS4_Scrollspy Component</h1>
      <p>This is the BS4_Scrollspy tutorial page content.</p>
    </div>
  );
}

export default BS4_Scrollspy;
